import { useEffect } from "react";
import { useState, createContext, useContext } from "react";
import config from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { serverLogout } from "../../Utils/serverLogout";
import Loading from "../Loading/Loading";

const base_url = config.base_url


const EmployeeContext = createContext(null)

export const EmployeeProvider = ({children})=>{
    const navigate = useNavigate()
    const location = useLocation()
    const [isAdmin, setIsAdmin] = useState()
    const [isAuth, setIsAuth] = useState()
    const [hasOTP, setHasOTP] = useState()
    const [hasPWD, setHasPWD] = useState()
    const [loaded, setLoaded] = useState(false)
    const logout = () =>{
      console.log('Ha entrado')
      serverLogout()
      .then(_=>{
        setIsAuth(false)
        setHasOTP(false)
        setIsAdmin(false)
        setHasPWD(false)
        return navigate('/admin/login')
      }).catch(e=>console.log(e))
    }
    useEffect(()=>{
        console.log('Admin provider')
        if (!location.pathname.startsWith("/admin")) {setLoaded(true);return}
        fetch(base_url+'admin/login',{
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            credentials:'include'
          }).then(res=>{
            if(res.status!==200) throw new Error()
            else return res.json()
          }).then(res=>{
            setIsAuth(true)
            
            console.log('Ejecutado')
            if (res.success){
                if (res.success.user_type.toLowerCase()==="administrator") setIsAdmin(true)
            }
            else{
                throw new Error()
            }
            setLoaded(true)
          }).catch(e=>{
            setLoaded(true)
            return
            // logout()
          })
    // }, [children?.props?.children.map(e=>{return e})])
      }, [children])
    return (<EmployeeContext.Provider value={{isAdmin, setIsAdmin, setHasPWD, hasPWD, setHasOTP, hasOTP, setIsAuth, isAuth, logout}}>
        {loaded?children:<Loading text={'Loading'}/>}
    </EmployeeContext.Provider>)
}

export const useEmployeeAuth=()=>{
    return useContext(EmployeeContext)
}